import React, { useState } from 'react';
import { useAuthContext } from '../../providers/AuthProvider';
import { ThemeSidebarPanel, BreadcrumbProvider } from '@textile-erp/ui';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { PageProvider } from '../../providers/PageContext';

interface AppLayoutProps {
  children: React.ReactNode;
}

function AppLayoutInner({ children }: AppLayoutProps) {
  const { user } = useAuthContext();
  const [isThemeSettingsOpen, setIsThemeSettingsOpen] = useState(false);
  if (!user) {
    return (
      <div className="min-h-screen bg-theme-secondary flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-theme-primary mb-4">Please Login</h1>
          <p className="text-theme-secondary">You need to be logged in to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <BreadcrumbProvider>
      <div className="h-screen bg-theme-primary flex overflow-hidden">
        {/* Sophisticated Dynamic Sidebar */}
        <Sidebar user={user} onThemeSettingsToggle={() => setIsThemeSettingsOpen(true)} />

        {/* Main content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Top navigation - Fixed */}
          <Header user={user} />

          {/* Main content area - Scrollable */}
          <main className="flex-1 overflow-auto bg-theme-secondary">
              {children}
          </main>
        </div>

        {/* Theme Sidebar Panel */}
        <ThemeSidebarPanel
          isOpen={isThemeSettingsOpen}
          onClose={() => setIsThemeSettingsOpen(false)}
        />
      </div>
    </BreadcrumbProvider>
  );
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <PageProvider>
      <AppLayoutInner>{children}</AppLayoutInner>
    </PageProvider>
  );
}